import { gql } from 'graphql-tag'

import { FRAGMENT_CONVERSATION_AVATARS_CONVERSATION } from './ConversationAvatars.hasura'
import { FRAGMENT_CONVERSATION_TITLE_CONVERSATION } from './ConversationTitle.hasura'

export const FRAGMENT_CONVERSATION_LIST_ITEM_CONVERSATION = gql`
  fragment ConversationListItemConversation on conversation {
    id
    external_uuid
    current_conversation_user: conversation_users(where: { user_id: { _eq: $currentUserId } }) {
      id
      last_read_at
    }
    last_message: messages(order_by: { created_at: desc }, limit: 1) {
      id
      body_safe
      type
      created_at
      hidden_at
      user {
        id
        virtual_display_name
      }
    }

    ...ConversationAvatarsConversation
    ...ConversationTitleConversation
  }
  ${FRAGMENT_CONVERSATION_AVATARS_CONVERSATION}
  ${FRAGMENT_CONVERSATION_TITLE_CONVERSATION}
`
